import { useAuth } from "@/hooks/useAuth";
import { trackAuthSignoutSuccess } from "@/lib/analytics";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  Avatar,
  Button,
  Chip,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState } from "react";
import AuthPromptDialog from "./AuthPromptDialog";

export default function AuthButton() {
  const { user, loading, signOut } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [authOpen, setAuthOpen] = useState(false);

  if (loading) return null;

  if (user) {
    return (
      <>
        <Chip
          avatar={
            <Avatar src={user.photoURL || undefined} sx={{ width: 24, height: 24 }} />
          }
          label={user.displayName?.split(" ")[0] || "You"}
          size="small"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{
            fontSize: "0.75rem",
            backgroundColor: "rgba(255,255,255,0.05)",
            color: "text.secondary",
            border: "1px solid rgba(255,255,255,0.08)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.1)",
            },
          }}
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          slotProps={{
            paper: {
              sx: {
                mt: 0.5,
                minWidth: 180,
                backgroundColor: "background.paper",
                border: "1px solid rgba(255,255,255,0.08)",
              },
            },
          }}
        >
          <MenuItem disabled sx={{ opacity: "1 !important" }}>
            <Typography sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
              {user.email}
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={async () => {
              setAnchorEl(null);
              await signOut();
              trackAuthSignoutSuccess();
            }}
          >
            <ListItemIcon>
              <LogoutIcon sx={{ fontSize: 18, color: "text.secondary" }} />
            </ListItemIcon>
            <ListItemText
              primary="Sign out"
              primaryTypographyProps={{ fontSize: "0.8rem" }}
            />
          </MenuItem>
        </Menu>
      </>
    );
  }

  return (
    <>
      <Button
        size="small"
        onClick={() => setAuthOpen(true)}
        sx={{
          fontSize: "0.7rem",
          color: "text.secondary",
          textTransform: "none",
          minWidth: "auto",
          "&:hover": { color: "primary.main" },
        }}
      >
        Sign In
      </Button>
      <AuthPromptDialog
        open={authOpen}
        onClose={() => setAuthOpen(false)}
        source="nav"
        reason="Sign in with your email or Google to post reports and save your home spot."
      />
    </>
  );
}
